import React, { Component } from 'react'
import { connect } from 'react-redux'
import { actualizarDatosMovimientoMercaderiaPendiente, updateTableMovimientosMercaderiaPendientes } from '../actions/TablaMovimientosMercaderiaActions'
import { TablaMovimientosMercaderiaPendientesView } from '../components/TablaMovimientosMercaderiaPendientesView'

class TablaMovimientosMercaderiaPendientes extends Component {
  componentDidMount () {
    this.props.actualizarDatosMovimientoMercaderiaPendiente()
  }

  render () {
    return (
      <div className='container-tabla-tareas-mov'>
        <TablaMovimientosMercaderiaPendientesView />
      </div>
    )
  }
}

const mapActionsToProps = {
  actualizarDatosMovimientoMercaderiaPendiente, updateTableMovimientosMercaderiaPendientes
}
const withRedux = connect(null, mapActionsToProps)

export default withRedux(
  TablaMovimientosMercaderiaPendientes)
